import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/person_dotted_80.png'
import _imports_1 from '@/assets/icons/everyone_500.png'


const _withScopeId = n => (_pushScopeId("data-v-3bb8524b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "family-group-member-list" }
const _hoisted_2 = {
  key: 1,
  class: "alert alert-primary alert-sm"
}
const _hoisted_3 = { class: "help-text" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-inline btn-link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#sharingTipModal"
}
const _hoisted_5 = {
  key: 0,
  class: "alert alert-primary alert-sm"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-inline btn-link",
  "data-bs-toggle": "modal",
  "data-bs-target": "#sharingLimitModal"
}, " View current sharing ", -1))
const _hoisted_7 = { class: "list-area" }
const _hoisted_8 = {
  key: 0,
  class: "list-actions"
}
const _hoisted_9 = { class: "view-options" }
const _hoisted_10 = {
  key: 0,
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_11 = {
  class: "btn btn-outline-secondary",
  for: "listModeRdo",
  title: "Simple list"
}
const _hoisted_12 = {
  class: "btn btn-outline-secondary",
  for: "groupModeRdo",
  title: "Group members by generation"
}
const _hoisted_13 = {
  key: 1,
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn btn-outline-secondary",
  for: "showSuggestedChk",
  title: "Show suggested members"
}, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_15 = {
  key: 0,
  class: "btn-group btn-group-sm"
}
const _hoisted_16 = {
  key: 1,
  class: "category-list list-unstyled"
}
const _hoisted_17 = { class: "category-item" }
const _hoisted_18 = { class: "category-subtext" }
const _hoisted_19 = {
  key: 2,
  class: "member-list list-unstyled"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "modal-icon"
}, null, -1))
const _hoisted_21 = { class: "sharing-tip-body" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " A group member is someone whose profile is visible to the group, or has joined the group. ", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Managed profiles are created automatically for people in the \"living window\""),
  /*#__PURE__*/_createElementVNode("li", null, "The living window includes anyone born in the last 110 years"),
  /*#__PURE__*/_createElementVNode("li", null, "Profiles in the living window are restricted by default and must be shared with a group to be visible to others"),
  /*#__PURE__*/_createElementVNode("li", null, "The group owner can share any profiles they manage with the group"),
  /*#__PURE__*/_createElementVNode("li", null, "The group owner can invite others to share profiles they manage with the group"),
  /*#__PURE__*/_createElementVNode("li", null, "Group members with permission to invite others to the group can also share profiles managed by the group owner with the group"),
  /*#__PURE__*/_createElementVNode("li", null, "Group members with permission to invite others can request others to share profiles they manage with the group"),
  /*#__PURE__*/_createElementVNode("li", null, "Group members should be able to see themselves and their parents and grandparents in the tree"),
  /*#__PURE__*/_createElementVNode("li", null, "To respect privacy, make sure people are only in a group with people they already know")
], -1))

import { computed, ref, reactive, watch, onBeforeMount, provide } from 'vue'
import { DataGroupMember, GroupMemberRole, ItemPermissions, PrincipalType } from '@/gp/GroupAdminModel'
import { livingWindowStart } from '@/rd/ResearchDataModel'
import { useUserStore } from '@/gp/UserStore'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import { useDataGroupInviteStore } from '@/gp/DataGroupInviteStore'
import { useDataGroupStore } from '@/gp/DataGroupStore'
import { useFamilyGroupStore } from '@/gp/FamilyGroupStore'
import { useFamilyGroupMemberStore } from '@/gp/FamilyGroupMemberStore'
import { useFamilyGroupInviteStore } from '@/gp/FamilyGroupInviteStore'
import { useViewPersonStore } from '@/rd/ViewPersonStore'
import { useViewFamilyStore } from '@/rd/ViewFamilyStore'
import { useTokenManager } from '@/auth/TokenManager'
import { SharingUser, useSharingLimiter } from './SharingLimiter'
import { useProfileSharingState } from './ProfileSharingState'
import { RelationshipCategory, PotentialMember, MaxAncestorGenerations, useFamilyGroupMemberManager, MemberListMode } from './FamilyGroupMemberManager'
import { AlignJustifyIcon, AlignRightIcon, EditIcon, LockIcon } from '@zhuowenli/vue-feather-icons'
import { LoadMode } from '@/util/AsyncData'
import { isDefined } from '@/util/TypeScriptUtil'
import { PatchChange } from '@/util/Api'
import { remove, uniq, uniqBy } from 'lodash'
import { ListPerson } from './FamilyGroupMemberListPerson'
import { getMultiSelectState } from '@/util/InputUtil'
import { refDebounced } from '@vueuse/core'
import LoadingIndicator from '@/util/LoadingIndicator.vue'
import ExpandableItem from '@/util/ExpandableItem.vue'
import FamilyGroupMemberListPerson from './FamilyGroupMemberListPerson.vue'
import FamilyGroupMemberModal from './FamilyGroupMemberModal.vue'
import FamilyGroupInviteModal from './FamilyGroupInviteModal.vue'
import FamilyGroupAddOtherModal from './FamilyGroupAddOtherModal.vue'
import FamilyGroupMemberRemoveModal from './FamilyGroupMemberRemoveModal.vue'
import DataGroupInviteModal from '@/manage/datagroups/DataGroupInviteModal.vue'
import UserAddModal from '@/manage/users/UserAddModal.vue'
import SharingLimitModal from './SharingLimitModal.vue'
import TipAlert from '@/util/TipAlert.vue'
import SharingLimitReachedModal from './SharingLimitReachedModal.vue'
import ProfileAddModal from '@/manage/profiles/ProfileAddModal.vue'
import { CompositeId } from '@/rd/CompositeId'
import Modal from '@/util/Modal.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyGroupMemberList',
  props: {
    familyGroupId: {},
    disableListActions: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const initialLoadCompleteRef = ref(false)
const loadingRef = ref(false)
const potentialMembers = reactive([]) as PotentialMember[]
const listPersons = reactive([]) as ListPerson[]
const relationshipCategories = reactive(new Map<string, RelationshipCategory>())
const suggestedParentIds = reactive(new Set<string>())
const listModeRef = ref(false)
const showSuggestedRef = ref(false)
const sharingUsersRef = ref<SharingUser[]>([])

const memberModalRef = ref<InstanceType<typeof FamilyGroupMemberModal>>()
const removeModalRef = ref<InstanceType<typeof FamilyGroupMemberRemoveModal>>()
const dataGroupInviteModalRef = ref<InstanceType<typeof DataGroupInviteModal>>()
const inviteModalRef = ref<InstanceType<typeof FamilyGroupInviteModal>>()
const addOtherModalRef = ref<InstanceType<typeof FamilyGroupAddOtherModal>>()
const addNewModalRef = ref<InstanceType<typeof ProfileAddModal>>()
const userAddModalRef = ref<InstanceType<typeof UserAddModal>>()
const sharingLimitReachedModalRef = ref<InstanceType<typeof SharingLimitReachedModal>>()

const userStore = useUserStore()
const familyGroupStore = useFamilyGroupStore()
const familyGroupMemberStore = useFamilyGroupMemberStore()
const memberManager = useFamilyGroupMemberManager()
const viewPersonStore = useViewPersonStore();
const viewFamilyStore = useViewFamilyStore()
const dataGroupMemberStore = useDataGroupMemberStore()
const dataGroupStore = useDataGroupStore()
const dataGroupInviteStore = useDataGroupInviteStore()
const userInviteStore = useFamilyGroupInviteStore()
const sharingLimiter = useSharingLimiter()
const profileSharingState = useProfileSharingState(() => props.familyGroupId)
const tokenManager = useTokenManager()

const asyncFamilyGroupRef = computed(() => familyGroupStore.getAsyncGroup(props.familyGroupId, LoadMode.EnsureLoaded))
const allUserMembersRef = computed(() => familyGroupMemberStore.getMembersForFamilyGroups([props.familyGroupId]))
const allUserInvitesRef = computed(() => userInviteStore.getInvitesForFamilyGroups([props.familyGroupId]))
const allSharingMembersRef = computed(() => dataGroupMemberStore.getMembersForFamilyGroups([props.familyGroupId]))
const allSharingMembersStableRef = refDebounced(allSharingMembersRef, 500)
const allSharingInvitesRef = computed(() => dataGroupInviteStore.getInvitesForFamilyGroup(props.familyGroupId))

const selfRef = computed(() => userStore.getAsyncSelf()?.data)
const familyGroupRef = computed(() => asyncFamilyGroupRef.value?.data)
const scopeFamilyIdRef = computed(() => familyGroupRef.value?.scopeFamilyId)
const ownerUserRef = computed(() => userStore.getAsyncUser(familyGroupRef.value?.ownerId, LoadMode.EnsureLoaded)?.data)
const isOwnerRef = computed(() => familyGroupRef.value?.ownerId == tokenManager.current.userId)

const sharedDataGroupsRef = computed(() => {
  const sharedGroupIds = allSharingMembersStableRef.value?.map(m => m.dataGroupId) ?? []
  return dataGroupStore.getAsyncGroupList(sharedGroupIds, LoadMode.EnsureLoaded).map(a => a.data).filter(isDefined)
})
const sharedProfileGroupsRef = computed(() => sharedDataGroupsRef.value.filter(dg => dg.isProfile))
const sharedResearchGroupsRef = computed(() => sharedDataGroupsRef.value.filter(dg => !dg.isProfile))
const sharedResearchGroupOwnersRef = computed(() => {
  const ownerIds = uniq(sharedResearchGroupsRef.value.map(dg => dg.ownerId))
  return userStore.getAsyncUserList(ownerIds, LoadMode.EnsureLoaded).map(a => a.data).filter(isDefined) // should be loaded with data groups
})
const isSharingLimitedRef = computed(() => sharedResearchGroupOwnersRef.value.some(u => u.limits?.sharingLimit))
const showSharingLimitAlertRef = computed(() => canAddMembersRef.value && isSharingLimitedRef.value && sharingUsersRef.value.length)
const ownerSharingLimitRef = computed(() => ownerUserRef.value?.limitsDisabled ? Infinity : ownerUserRef.value?.limits?.sharingLimit ?? Infinity)
const hasReachedSharingLimitRef = computed(() => isOwnerRef.value && sharingUsersRef.value.length >= ownerSharingLimitRef.value)

const showListModeOptionRef = computed(() => someRelatedRef.value)
const showSuggestedOptionRef = computed(() => !!scopeFamilyIdRef.value && hasSuggestedRef.value)
const hasSuggestedRef = computed(() => listPersons.some(lp => lp.isSuggested))
const isSharingModeRef = computed(() => showSuggestedRef.value && canAddMembersRef.value)
const showListOptionsRef = computed(() => showListModeOptionRef.value || showSuggestedOptionRef.value)
const visibleListPersonsRef = computed(() => listPersons.filter(lp => showSuggestedRef.value || !lp.isSuggested))
const someRelatedRef = computed(() => relationshipCategories.size > 0)
const showRelationshipsRef = computed(() => !listModeRef.value && someRelatedRef.value)
const showListActionsRef = computed(() => canAddMembersRef.value)

const groupPermissionsRef = computed(() => familyGroupStore.getLoadedPermissions(props.familyGroupId)) // loaded by parent
const canListMembersRef = computed(() => (groupPermissionsRef.value ?? 0) & ItemPermissions.ListItems)
const canAddMembersRef = computed(() => (groupPermissionsRef.value & ItemPermissions.AddItems) > 0)

provide('profileSharingState', profileSharingState)

onBeforeMount(() => initialLoadCompleteRef.value = false)

watch(canAddMembersRef, () => showSuggestedRef.value = canAddMembersRef.value, { immediate: true })

// NOTE: calculating sharing users requires many inputs, but to limit dependency tracking, we only watch the ones that can 
// be directly changed in this context
watch([
    allUserMembersRef, 
    allUserInvitesRef
  ], 
  async () => {
    sharingUsersRef.value = [] // reset until we get a result

    if (!isOwnerRef.value)
      return // account sharing only matters for FG owner

    sharingUsersRef.value = await sharingLimiter.getSharingUsersAsync()
}, { immediate: true, deep: true }) // deep to track invitation change (e.g. pending -> cancelled)

watch([
    props,
    scopeFamilyIdRef, // react when FG scope family changed
    allUserMembersRef, // react when FG users added/removed/changed
    allUserInvitesRef, // react when FG user invites added/removed/changed
    allSharingMembersStableRef, // react when shared trees or profiles added/removed/changed
    sharedProfileGroupsRef, // react when properties of shared profile groups change (e.g. isChild, isUserProfile)
    allSharingInvitesRef, // react when sharing invites added/removed/changed
  ],
  async () => {
    console.log('FamilyGroupMemberList: potential members changed')
    await refreshPotentialMembersAsync()
}, { immediate: true, deep: true })

async function refreshPotentialMembersAsync() {
  if (!props.familyGroupId)
    return

  if (loadingRef.value)
    return // ignore nested requests

  loadingRef.value = true

  try {
    console.log('FamilyGroupMemberList: refreshing potential members')
    await asyncFamilyGroupRef.value?.whenLoadCompleted
    if (!familyGroupRef.value)
      return

    // TODO: is this hack necessary, or should other components fix their reactivity to detect new instances?
    const newMembers = await memberManager.getPotentialMembersAsync(familyGroupRef.value)
    console.log('FamilyGroupMemberList: refreshing potential members...done')
    const oldMemberMap = new Map(potentialMembers.map(pm => [pm.id, pm]))
    potentialMembers.length = 0

    for (const newMember of newMembers) {
      const oldMember = oldMemberMap.get(newMember.id)
      if (oldMember) {
        // preserve old instances so reactive effects on other components still work
        Object.assign(oldMember, newMember)
        potentialMembers.push(oldMember) // re-add updated instance
      }
      else {
        potentialMembers.push(newMember) // add new instance
      }
    }

    refreshListPersons()
  }
  finally {
    loadingRef.value = false
    initialLoadCompleteRef.value = true
  }
}

function refreshListPersons() {
  relationshipCategories.clear()
  suggestedParentIds.clear()

  const newListPersons: ListPerson[] = []
  const potentialMembersMap = new Map(potentialMembers.map(pm => [pm.id, pm]))

  const scopeFamily = viewFamilyStore.getAsyncFamily(scopeFamilyIdRef.value)?.data // loaded by member manager
  if (scopeFamily) {
    // NOTE: member manager already loaded view persons for scope family, ancestors, and descendants
    const faFam = [...viewPersonStore.getLoadedAncestors(scopeFamily.fatherId, MaxAncestorGenerations)]
    const moFam = [...viewPersonStore.getLoadedAncestors(scopeFamily.motherId, MaxAncestorGenerations)]

    const scopeFam = viewPersonStore.getLoadedPersonList(scopeFamily.spouseIds)
    
    const children = viewFamilyStore.getLoadedChildren(scopeFamily.id!).children
    const childrenSpouseFamilies = children.flatMap(ch => viewFamilyStore.getLoadedSpouseFamilies(ch.id!).spouseFamilies)
    const childGenerationIds = uniq([...children.map(ch => ch.id!), ...childrenSpouseFamilies.flatMap(sf => sf.spouseIds)])
    const childGeneration = viewPersonStore.getLoadedPersonList(childGenerationIds)

    const grandchildren = childrenSpouseFamilies.flatMap(sf => viewFamilyStore.getLoadedChildren(sf.id!).children)
    const grandchildrenSpouseFamilies = grandchildren.flatMap(ch => viewFamilyStore.getLoadedSpouseFamilies(ch.id!).spouseFamilies)
    const grandchildGenerationIds = uniq([...grandchildren.map(ch => ch.id!), ...grandchildrenSpouseFamilies.flatMap(sf => sf.spouseIds)])
    const grandchildGeneration = viewPersonStore.getLoadedPersonList(grandchildGenerationIds)

    // store the relationships for each view person
    faFam.forEach(vp => relationshipCategories.set(vp.id!, RelationshipCategory.Ancestors))
    moFam.forEach(vp => relationshipCategories.set(vp.id!, RelationshipCategory.Ancestors))
    scopeFam.forEach(vp => relationshipCategories.set(vp.id!, RelationshipCategory.Scope))
    childGeneration.forEach(vp => relationshipCategories.set(vp.id!, RelationshipCategory.Child))
    grandchildGeneration.forEach(vp => relationshipCategories.set(vp.id!, RelationshipCategory.Grandchild))

    for (const vp of [...faFam, ...moFam, ...scopeFam, ...childGeneration, ...grandchildGeneration]) {
      newListPersons.push(ListPerson.fromViewPerson(vp, potentialMembersMap))
    }

    const allPersonIds = new Set(newListPersons.map(lp => lp.viewPerson!.id!))
    const sharedPersonIds = newListPersons.filter(p => p.viewPerson && p.potentialMembers.some(pm => pm.isProfileShared)).map(p => p.viewPerson!.id!)
    let childIds = [...sharedPersonIds]
    while (childIds.length) {
      const parentIds = childIds.flatMap(id => viewPersonStore.getLoadedParentIds(id).parentIds).filter(id => allPersonIds.has(id))
      parentIds.forEach(id => suggestedParentIds.add(id))
      childIds = parentIds
    }
  }

  // ensure potential member view persons added to list
  // NOTE: member manager already loaded view persons for potential members
  const memberPersonIds = potentialMembers.map(pm => pm.profilePerson?.id).filter(isDefined)
  const memberViewPersons = viewPersonStore.getLoadedPersonList(memberPersonIds)
  newListPersons.push(...memberViewPersons.map(vp => ListPerson.fromViewPerson(vp, potentialMembersMap)))

  // ensure user-only potential members (no view person) added to list
  const userOnlyMembers = potentialMembers.filter(pm => !pm.profilePerson) // no visible profile person
  newListPersons.push(...userOnlyMembers.map(ListPerson.fromPotentialMember))

  // drop view persons with no potential member
  remove(newListPersons, listPerson => listPerson.isEmpty)

  // remove duplicates and sort by display name
  const uniquePersons = uniqBy(newListPersons, listPerson => listPerson.id)
  const sortedPersons = uniquePersons.sort((a, b) => a.displayName.localeCompare(b.displayName))

  listPersons.length = 0
  listPersons.push(...sortedPersons)
}

const orderedCategories = [
    RelationshipCategory.Ancestors,
    RelationshipCategory.Scope,
    RelationshipCategory.Child,
    RelationshipCategory.Grandchild,
    RelationshipCategory.None,
]

function categoryName(rel: RelationshipCategory) {
  switch (rel) {
    case RelationshipCategory.Ancestors: return 'Parents and grandparents'
    case RelationshipCategory.Scope: return 'Common ancestors'
    case RelationshipCategory.Child: return 'Children and spouses'
    case RelationshipCategory.Grandchild: return 'Grandchildren and spouses'
    default: return 'Other members'
  }
}

function shouldShowCategory(rel: RelationshipCategory) {
  // hide 'Ancestors' category if empty (e.g. ancestors outside living window)
  return (rel >= RelationshipCategory.Scope) || categoryListPersons(rel).length > 0
}

function canSelectMember(pm: PotentialMember) {
  return pm.isProfileOwner && !pm.hasPendingInvite
}

function isMemberSelected(pm: PotentialMember) {
  return profileSharingState.isShared(pm.profileGroupId)
}

function categoryListPersons(rel: RelationshipCategory) {
  if (rel == RelationshipCategory.None) {
    return visibleListPersonsRef.value.filter(listPerson => !relationshipCategories.has(listPerson.id!))
  }
  else {
    return visibleListPersonsRef.value.filter(listPerson => relationshipCategories.get(listPerson.id!) == rel)
  }
}

function categoryMembers(rel: RelationshipCategory) {
  return categoryListPersons(rel).flatMap(lp => lp.potentialMembers)
}

function canSelectCategory(rel: RelationshipCategory) {
  return categoryMembers(rel).some(canSelectMember)
}

function categorySelectState(rel: RelationshipCategory) {
  const selectableMembers = categoryMembers(rel)//.filter(canSelectMember)
  if (rel == RelationshipCategory.Child && selectableMembers.every(pm => !isMemberSelected(pm))) {
    console.log('doh!')
  }
  return getMultiSelectState(selectableMembers, isMemberSelected)
}

async function toggleCategorySelected(rel: RelationshipCategory) {
  const selectableMembers = categoryMembers(rel).filter(canSelectMember)
  const newValue = !getMultiSelectState(selectableMembers, isMemberSelected) // none/some -> all, all -> none
  profileSharingState.shareProfiles(selectableMembers.map(pm => pm.profileGroupId!), newValue)
}

function isSuggestedParent(listPerson: ListPerson) {
  return listPerson.viewPerson && suggestedParentIds.has(listPerson.viewPerson.id!)
}

function onMemberClick(pm: PotentialMember) {
  memberModalRef.value?.open(pm)
}

function onShowMemberInvite(inviteId: string) {
  inviteModalRef.value?.openEdit(inviteId)
}

function onInviteMember(pm: PotentialMember) {
  if (isSharingLimitedRef.value && hasReachedSharingLimitRef.value) {
    sharingLimitReachedModalRef.value?.open()
  }
  else {
    inviteModalRef.value?.openNew(props.familyGroupId, pm.profileGroup!.startItemId!)
  }
}

function showAddPersonModal() {
  if (isSharingLimitedRef.value && hasReachedSharingLimitRef.value) {
    sharingLimitReachedModalRef.value?.open()
  }
  else {
    addOtherModalRef.value?.open()
  }
}

async function onProfileAdded(profilePersonId: string) {
  const profileGroupId = CompositeId.getGroupId(profilePersonId)!
  const dm = {
    dataGroupId: profileGroupId,
    principalType: PrincipalType.FamilyGroup,
    principalId: props.familyGroupId,
    role: GroupMemberRole.Viewer,
  } as DataGroupMember
  await dataGroupMemberStore.addAsync(profileGroupId, dm)
}

async function onInviteOther(profilePersonId: string, profileOnly: boolean) {
  if (profileOnly) {
    dataGroupInviteModalRef.value?.openNew(CompositeId.getGroupId(profilePersonId)!, props.familyGroupId)
  }
  else {
    inviteModalRef.value?.openNew(props.familyGroupId, profilePersonId)
  }
}

async function onAddUser(pm: PotentialMember) {
  userAddModalRef.value?.open(pm.profileGroupId!)
}

async function onShowSharingInvite(inviteId: string) {
  dataGroupInviteModalRef.value?.openEdit(inviteId)
}

async function onShareProfile(profileGroupId: string) {
  dataGroupInviteModalRef.value?.openNew(profileGroupId!, props.familyGroupId)
}

async function onRemoveProfile(pm: PotentialMember) {
  profileSharingState.shareProfiles([pm.profileGroupId!], false)
}

async function onRemoveUser(pm: PotentialMember) {
  removeModalRef.value?.open(pm)
}

async function removeMember(pm: PotentialMember) {
  if (!pm.member)
    throw new Error('No member to remove')

  await familyGroupMemberStore.deleteAsync(pm.member)
  removeModalRef.value?.close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!initialLoadCompleteRef.value)
      ? (_openBlock(), _createBlock(LoadingIndicator, { key: 0 }))
      : (!canListMembersRef.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(LockIcon)),
            _createTextVNode(" You do not have permission to see the members of this group. ")
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_3, [
              (canAddMembersRef.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" Choose which people should be visible to the group, then invite people to join. "),
                    _createElementVNode("button", _hoisted_4, [
                      _createVNode(_unref(EditIcon)),
                      _createTextVNode(" Learn more ")
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Managed profiles shared with the group and users that have joined the group. ")
                  ], 64))
            ]),
            (showSharingLimitAlertRef.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(" Users added to this group count toward the sharing limit for your account. "),
                  _hoisted_6
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (showListOptionsRef.value || showListActionsRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (showListModeOptionRef.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "listMode",
                              id: "listModeRdo",
                              autocomplete: "off",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((listModeRef).value = $event)),
                              value: true
                            }, null, 512), [
                              [_vModelRadio, listModeRef.value]
                            ]),
                            _createElementVNode("label", _hoisted_11, [
                              _createVNode(_unref(AlignJustifyIcon))
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "btn-check",
                              name: "listMode",
                              id: "groupModeRdo",
                              autocomplete: "off",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((listModeRef).value = $event)),
                              value: false
                            }, null, 512), [
                              [_vModelRadio, listModeRef.value]
                            ]),
                            _createElementVNode("label", _hoisted_12, [
                              _createVNode(_unref(AlignRightIcon))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (showSuggestedOptionRef.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "btn-check",
                              id: "showSuggestedChk",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showSuggestedRef).value = $event))
                            }, null, 512), [
                              [_vModelCheckbox, showSuggestedRef.value]
                            ]),
                            _hoisted_14
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (showListActionsRef.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn btn-outline-secondary",
                            onClick: showAddPersonModal
                          }, " Add someone ")
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (showRelationshipsRef.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderedCategories, (rel) => {
                      return _createElementVNode("li", { key: rel }, [
                        (shouldShowCategory(rel))
                          ? (_openBlock(), _createBlock(ExpandableItem, {
                              key: 0,
                              checkbox: isSharingModeRef.value,
                              checked: categorySelectState(rel) === true,
                              indeterminate: categorySelectState(rel) === undefined,
                              checkDisabled: !canSelectCategory(rel),
                              expanded: "",
                              onCheck: ($event: any) => (toggleCategorySelected(rel))
                            }, {
                              item: _withCtx(() => [
                                _createElementVNode("h5", _hoisted_17, [
                                  _createTextVNode(_toDisplayString(categoryName(rel)) + " ", 1),
                                  _createElementVNode("span", _hoisted_18, "(" + _toDisplayString(categoryListPersons(rel).length) + ")", 1)
                                ])
                              ]),
                              content: _withCtx(() => [
                                _createElementVNode("ul", {
                                  class: _normalizeClass(["member-list list-unstyled", { 'show-select': isSharingModeRef.value }])
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryListPersons(rel), (listPerson) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: listPerson.id
                                    }, [
                                      _createVNode(FamilyGroupMemberListPerson, {
                                        "family-group-id": _ctx.familyGroupId,
                                        "list-person": listPerson,
                                        "allow-add": canAddMembersRef.value,
                                        sharingMode: isSharingModeRef.value,
                                        "suggested-parent": isSuggestedParent(listPerson),
                                        onMemberInvite: onInviteMember,
                                        onMemberClick: onMemberClick
                                      }, null, 8, ["family-group-id", "list-person", "allow-add", "sharingMode", "suggested-parent"])
                                    ]))
                                  }), 128))
                                ], 2)
                              ]),
                              _: 2
                            }, 1032, ["checkbox", "checked", "indeterminate", "checkDisabled", "onCheck"]))
                          : _createCommentVNode("", true)
                      ])
                    }), 64))
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleListPersonsRef.value, (listPerson) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: listPerson.id
                      }, [
                        _createVNode(FamilyGroupMemberListPerson, {
                          "family-group-id": _ctx.familyGroupId,
                          "list-person": listPerson,
                          "allow-add": canAddMembersRef.value,
                          sharingMode: isSharingModeRef.value,
                          "suggested-parent": isSuggestedParent(listPerson),
                          onMemberInvite: onInviteMember,
                          onMemberClick: onMemberClick
                        }, null, 8, ["family-group-id", "list-person", "allow-add", "sharingMode", "suggested-parent"])
                      ]))
                    }), 128))
                  ]))
            ])
          ], 64)),
    _createVNode(SharingLimitModal, { id: "sharingLimitModal" }),
    _createVNode(Modal, {
      id: "sharingTipModal",
      info: ""
    }, {
      icon: _withCtx(() => [
        _hoisted_20
      ]),
      title: _withCtx(() => [
        _createTextVNode("Group members")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _hoisted_23,
          _createVNode(TipAlert, { small: "" }, {
            default: _withCtx(() => [
              _createTextVNode(" To make different people visible to different sets of family members, use multiple groups. ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(FamilyGroupMemberModal, {
      ref_key: "memberModalRef",
      ref: memberModalRef,
      "family-group-id": _ctx.familyGroupId,
      onShareProfile: onShareProfile,
      onRemoveProfile: onRemoveProfile,
      onInvite: onInviteMember,
      onAddUser: onAddUser,
      onViewSharingInvite: onShowSharingInvite,
      onViewGroupInvite: onShowMemberInvite,
      onRemoveUser: onRemoveUser
    }, null, 8, ["family-group-id"]),
    _createVNode(DataGroupInviteModal, {
      ref_key: "dataGroupInviteModalRef",
      ref: dataGroupInviteModalRef
    }, null, 512),
    _createVNode(FamilyGroupInviteModal, {
      ref_key: "inviteModalRef",
      ref: inviteModalRef
    }, null, 512),
    _createVNode(SharingLimitReachedModal, {
      ref_key: "sharingLimitReachedModalRef",
      ref: sharingLimitReachedModalRef
    }, null, 512),
    _createVNode(FamilyGroupAddOtherModal, {
      ref_key: "addOtherModalRef",
      ref: addOtherModalRef,
      "family-group-id": _ctx.familyGroupId,
      "potential-members": potentialMembers,
      onInvite: onInviteOther,
      onAddNew: _cache[3] || (_cache[3] = ($event: any) => (addNewModalRef.value?.open()))
    }, null, 8, ["family-group-id", "potential-members"]),
    _createVNode(ProfileAddModal, {
      ref_key: "addNewModalRef",
      ref: addNewModalRef,
      onAdded: onProfileAdded
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Add someone new ")
      ]),
      instructions: _withCtx(() => [
        _createTextVNode(" Add someone who is not an existing user or person in your tree. ")
      ]),
      _: 1
    }, 512),
    _createVNode(FamilyGroupMemberRemoveModal, {
      ref_key: "removeModalRef",
      ref: removeModalRef,
      onOk: removeMember
    }, null, 512),
    _createVNode(UserAddModal, {
      ref_key: "userAddModalRef",
      ref: userAddModalRef
    }, null, 512)
  ]))
}
}

})